import { User } from '@qogita/canary-types'

import { isQogitaUserEmail } from './isQogitaUserEmail'

export const getIsValidPortalUser = (user: User) => {
  const isQogitaUser = isQogitaUserEmail(user.email)

  const isValidPortalUser =
    isQogitaUser || user.isWarehouseUser || user.isSeller

  return isValidPortalUser
}
